import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";

import Svg from "../../components/svg/Svg";
import { Toggle as ToggleIcon } from "../../components/svg/svgImageList";
import { translationService } from "../../services/translation/TranslationService";

interface DataGridTotalResultsProps {
  itemTypeKey: string;
  totalResults: number;
  selectedItemsCount?: number;
  insideDialog?: boolean;
  singleSelection?: boolean;
  isCollapsible?: boolean;
  handleCollapse?: (collapse: boolean) => void;
}

export default observer(function DataGridTotalResults(props: DataGridTotalResultsProps) {
  const {
    itemTypeKey,
    totalResults,
    selectedItemsCount,
    insideDialog = false,
    singleSelection,
    isCollapsible = false,
    handleCollapse,
  } = props;
  const [openGrid, setOpenGrid] = useState(true);
  const translatedItemType = translationService.translate(itemTypeKey);

  const handleOpenGrid = useCallback(() => {
    setOpenGrid((o) => !o);
    handleCollapse && handleCollapse(!openGrid);
  }, [handleCollapse, openGrid]);

  if (insideDialog) return null;

  return (
    <section className="data-grid-total-results">
      {openGrid && (
        <h3>
          {selectedItemsCount && !singleSelection
            ? translationService.translate("general.list.total-results-and-selected-items", {
                itemType: translatedItemType,
                totalResults,
                selectedItemsCount,
              })
            : translationService.translate("general.list.total-results-items", {
                itemType: translatedItemType,
                totalResults,
              })}
        </h3>
      )}
      {isCollapsible && (
        <header className="collapsible-header">
          <Svg svg={ToggleIcon} className={!openGrid ? "reverse" : ""} onClick={handleOpenGrid} />
        </header>
      )}
    </section>
  );
});
